
import React from 'react';
import { Router, IndexRoute, Route } from 'react-router';

import App from './App';
import MainHome from './Home/Home';
import AboutHome from './Home/AboutHome';
import ResearchHome from './Research/ResearchHome';
import ResearchArticle from './Research/ResearchArticle';
import OpenSourceHome from './OpenSource/OpenSourceHome';
import NewsHome from './News/NewsHome';
import NewsArticle from './News/NewsArticle';
import TechnicalHome from './Technical/TechnicalHome';
import BlogHome from './Blog/BlogHome';
import BlogPost from './Blog/BlogPost';
import NotFoundPage from './components/NotFound';

const Routes = (props) => (
  <Router {...props}>
    <Route path="/" component={App}>
      <IndexRoute component={MainHome} />
      <Route path="/" component={MainHome} />
      <Route path="/technical" component={TechnicalHome} />
      <Route path="/research" component={ResearchHome} />
      <Route path="/research/article" component={ResearchArticle} />
      <Route path="/about" component={AboutHome} />
      <Route path="/news" component={NewsHome} />
      <Route path="/news/article" component={NewsArticle} />
      
      <Route path="/opensource" component={OpenSourceHome} />
      <Route path="/p/:page" component={BlogHome} />
      <Route path="/post/:slug" component={BlogPost} />

      <Route path="*" component={NotFoundPage}/>
    </Route>
  </Router>
);

export default Routes;


// WEBPACK FOOTER //
// ./src/routes.js